module.exports = __webpack_public_path__ + "img/hedwig-and-the-angry-inch.c8edf329.png";